// Core animation utilities
export {
  PageTransitionAnimation,
  AnimationPresets,
  createPageTransition,
  getGlobalTransition,
  initializeGlobalTransition,
} from "./animations";

// React components
export { PageTransitionSVG } from "./svg";

// Export types
export type { default as gsap } from "gsap";

// Version
export const VERSION = "1.0.0";
